import { Markdown, Popover, PopoverContent, PopoverTrigger } from '@ibsys/kit';
import { InfoIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn, MARKDOWN_CODE_CLASS } from '@/shared/lib';
import { IconButton } from '@/shared/ui';

/**
 * Значок «i» у признака «Список»: по клику открывает справку о том, как значение списка выглядит
 * в сырых данных и чем список отличается от множественного выбора. Справку читают, решая, ставить ли
 * признак, поэтому значок активен и тогда, когда сам признак недоступен.
 */
export const ListInfoButton: FC = () => {
  const { t } = useTranslation('attributes');

  return (
    <Popover>
      <IconButton
        size="icon"
        className="size-6"
        label={t('listInfo.open')}
        icon={<InfoIcon />}
        trigger={PopoverTrigger}
      />
      {/*
        Ширина — под самую длинную строку примеров: элемент структуры-списка читается одной строкой.
        Высоту и ширину окна ограничивает свободным местом экрана сам PopoverContent и уводит остаток
        в прокрутку: снимать ограничение (`max-h-none`, своя обёртка с прокруткой) нельзя — на узком
        экране справка выйдет за его края. Примеры переносятся, а не прокручиваются вбок по той же причине
      */}
      <PopoverContent
        className={cn('w-2xl p-3 text-sm [&_pre]:break-words [&_pre]:whitespace-pre-wrap', MARKDOWN_CODE_CLASS)}
        align="start"
      >
        <Markdown>{t('listInfo.content')}</Markdown>
      </PopoverContent>
    </Popover>
  );
};
